import { render, staticRenderFns } from "./UserCash.vue?vue&type=template&id=2e65df2b&scoped=true&"
import script from "./UserCash.vue?vue&type=script&lang=js&"
export * from "./UserCash.vue?vue&type=script&lang=js&"
import style0 from "./UserCash.vue?vue&type=style&index=0&id=2e65df2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e65df2b",
  null
  
)

export default component.exports